import { FaClock, FaMapMarkerAlt, FaUserTie, FaDollarSign, FaTags, FaCalendarAlt, FaPhone, FaUsers, FaHeadset, FaCar, FaStar, FaCalendarCheck, FaThumbsUp, FaCarAlt, FaCarSide, FaUserFriends, FaSuitcaseRolling, FaGasPump, FaCogs, FaPalette, FaRoad, FaTachometerAlt } from 'react-icons/fa';


// Function to render the appropriate icon based on the service name
export const renderIcon = (iconName) => {

  // Convert the service name to lowercase
  const lowercaseServiceName = iconName.toLowerCase();

  // Check the lowercase service name and return the corresponding icon component
  switch (lowercaseServiceName) {

    /*----- Service Icons -----*/
    case 'variety of cars':
      return <FaCar />; // Car icon

    case 'best price guarantee':
      return <FaStar />; // Star icon

    case 'available 24 x 7':
      return <FaHeadset />; // Support icon

    case 'phone reservation':
      return <FaPhone />; // Phone icon

    case 'reservation anytime':
      return <FaCalendarCheck />; // Calendar icon

    case 'best quality cars':
      return <FaThumbsUp />; // Quality icon

    /*----- Car Details Icons -----*/
    case 'year':
      return <FaCar />; // Car icon

    case 'carmake':
      return <FaCarSide />; // Side-view car

    case 'carmodel':
      return <FaCarAlt />; // Alt car icon

    case 'cartype':
      return <FaCarSide />; // Vehicle type

    case 'seats':
      return <FaUserFriends />; // Group icon

    case 'coloroptions':
      return <FaPalette />; // Color palette

    case 'suitcase':
      return <FaSuitcaseRolling />; // Suitcase icon

    case 'fueltype':
      return <FaGasPump />; // Gas pump

    case 'transmission':
      return <FaCogs />; // Gear icon

    case 'costpermile':
      return <FaDollarSign />; // Dollar icon

    case 'mileage':
      return <FaRoad />; // Road icon

    case 'topspeed':
      return <FaTachometerAlt />; // Speedometer

    case 'drivetrain':
      return <FaCogs />; // Gear system

    /*----- Page Sidebar -----*/
    case 'date':
      return <FaCalendarAlt />; // Calendar icon

    case 'duration':
      return <FaClock />; // Clock icon

    case 'client':
      return <FaUsers />; // Users icon

    case 'category':
      return <FaTags />; // Tags icon

    case 'location':
      return <FaMapMarkerAlt />; // Location icon

    case 'cost':
      return <FaDollarSign />; // Dollar icon

    case 'projectlead':
      return <FaUserTie />; // User Tie icon

    default:
      return null; // No matching icon

  }

};